import { isMobile } from "react-device-detect";

export const mapConfig = {
  width: 8000,
  height: 6600,
  pointRadius: 3, // Percent around a pin (* percent zoomed) before it should cluster
  zoom: {
    default: isMobile ? 0.4 : 0.7,
    max: 1,
    min: isMobile ? 0.2 : 0.05,
  },
  tiles: {
    x: 8,
    y: 6,
  },
};
